import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LeavesHistoryProps {
  className?: string;
  width?: number;
  height?: number;
}

const LeavesHistoryIcon = function LeavesHistoryIcon({
  className,
  width,
  height,
}: LeavesHistoryProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_231_7291)">
        <circle className={twMerge(className, 'fill-transparent')} cx="12" cy="12" r="6" stroke="#222222" />
        <path className={twMerge(className, 'fill-transparent')} d="M3.48017 12.9878C3.70414 14.9183 4.57711 16.7155 5.95606 18.085C7.33502 19.4545 9.13819 20.3151 11.0702 20.5257C13.0022 20.7364 14.9485 20.2847 16.5902 19.2446C18.2319 18.2045 19.4717 16.6377 20.1065 14.8008C20.7413 12.964 20.7334 10.966 20.0842 9.13415C19.4349 7.30234 18.1828 5.74533 16.533 4.71819C14.8831 3.69104 12.9334 3.25467 11.0031 3.48055C9.0728 3.70643 7.27646 4.58118 5.90833 5.96148" stroke="#222222" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-transparent')} d="M15 13H12.25C12.1119 13 12 12.8881 12 12.75V10" stroke="#222222" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-transparent')} d="M6.08789 2.67773L5.51255 5.70783C5.48447 5.85572 5.5925 5.99471 5.74274 6.00399L8.80498 6.19319" stroke="#222222" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_231_7291">
          <rect className={twMerge(className, 'fill-transparent')} width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

LeavesHistoryIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default LeavesHistoryIcon;
